import request from '@/utils/request'

// 查询空间列表
export function listSpace(query) {
  return request({
    url: '/system/space/list',
    method: 'get',
    params: query,
  })
}

// 查询空间分页
export function pageSpace(query) {
  return request({
    url: '/system/space/page',
    method: 'get',
    params: query,
  })
}

// 查询空间详细
export function getSpace(data) {
  return request({
    url: '/system/space/detail',
    method: 'get',
    params: data,
  })
}

// 新增空间
export function addSpace(data) {
  return request({
    url: '/system/space/add',
    method: 'post',
    data: data,
  })
}

// 修改空间
export function updateSpace(data) {
  return request({
    url: '/system/space/edit',
    method: 'post',
    data: data,
  })
}

// 删除空间
export function delSpace(data) {
  return request({
    url: '/system/space/delete',
    method: 'post',
    data: data,
  })
}

// 导入空间数据
export function importData(data) {
  return request({
    url: '/system/space/importData',
    method: 'post',
    data: data,
  })
}

// 修改空间状态
export function changeSpaceStatus(data) {
  return request({
    url: '/system/space/editStatus',
    method: 'post',
    data: data,
  })
}

// 查询空间可选择的信标列表
export function listBeaconOptionsForSpace(projectId, spaceId) {
  return request({
    url: '/system/beacon/listOptionsForSpace',
    method: 'get',
    params: {
      projectId: projectId,
      spaceId: spaceId || undefined,
    },
  })
}